// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2Hhnp","content":"GlobalSearch_content__2m7jT"};